<nav>
  <span class="main">
    <ng-content select="[top-nav-main]"></ng-content>
  </span>
  <ng-content select="[top-nav-corner]"></ng-content>
</nav>
<ng-content select="[top-nav-content]"></ng-content>
